/**
 * 
 */
export default (target) => {
  const obj = {}
  for (const [key, value] of new FormData(target)) {
    obj[key] = value
  }
  return obj
}